@if (isInModal) {
<div>
  <!-- <ion-toolbar color="primary"> -->
  <h4>Edit User</h4>
  <!-- </ion-toolbar> -->
</div>
}

<mat-grid-list [cols]="1">
  <div class="center-column">
    <div class="wrapper center-column">
      <form [formGroup]="validations_form">
        <mat-form-field class="form-field-width">
          <mat-label>Name</mat-label>
          <input matInput type="text" formControlName="nameControl" required>
        </mat-form-field>
        <div>
          @for (validation of validation_messages.nameControl; track validation) { @if ( validations_form.get('nameControl').hasError(validation.type) &&
          (validations_form.get('nameControl').dirty || validations_form.get('nameControl').touched) ) {
          <div class="validation-error-message">
            {{ validation.message }}
          </div>
          } }
        </div>

        <mat-form-field class="form-field-width">
          <mat-label>Surname</mat-label>
          <input matInput type="text" formControlName="surnameControl" required>
        </mat-form-field>
        <div>
          @for (validation of validation_messages.surnameControl; track validation) { @if ( validations_form.get('surnameControl').hasError(validation.type) &&
          (validations_form.get('surnameControl').dirty || validations_form.get('surnameControl').touched) ) {
          <div class="validation-error-message">
            {{ validation.message }}
          </div>
          } }
        </div>

        <mat-form-field class="form-field-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="emailControl" required />
        </mat-form-field>
        <div>
          @for (validation of validation_messages.emailControl; track validation) { @if ( validations_form.get('emailControl').hasError(validation.type) &&
          (validations_form.get('emailControl').dirty || validations_form.get('emailControl').touched) ) {
          <div class="validation-error-message">
            {{ validation.message }}
          </div>
          } }
        </div>
      </form>
      <huge-row class="mat-margin-top mat-align-items-center">
        <mat-col>
          <button class="btn primary-btn" expand="full" (click)="updateUser()">Save</button>
        </mat-col>
      </huge-row>
      <huge-row>
      </huge-row>
    </div>
  </div>
</mat-grid-list>
